<script setup lang="ts">
import type { ListboxGroupProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ListboxGroup, ListboxGroupLabel, useId } from 'reka-ui';
import { computed, onMounted, onUnmounted } from 'vue';
import { cn } from '@/lib/utils';
import { provideCommandGroupContext, useCommand } from '.';

const props = defineProps<
    ListboxGroupProps & {
        class?: HTMLAttributes['class'];
        heading?: string;
    }
>();

const delegatedProps = reactiveOmit(props, 'class');

const { allGroups, filterState, shouldFilter } = useCommand();
const id = useId();

const isRender = computed(() =>
    !filterState.search || !shouldFilter.value ? true : filterState.filtered.groups.has(id),
);

provideCommandGroupContext({ id });
onMounted(() => {
    if (!allGroups.value.has(id)) allGroups.value.set(id, new Set());
});
onUnmounted(() => {
    allGroups.value.delete(id);
});
</script>

<template>
    <ListboxGroup
        v-bind="delegatedProps"
        :id="id"
        :class="cn('overflow-hidden p-1', props.class)"
        :hidden="isRender ? undefined : true"
    >
        <ListboxGroupLabel v-if="heading" class="text-md px-4 pt-8 pb-1 font-medium text-(--text-muted)">
            {{ heading }}
        </ListboxGroupLabel>
        <slot />
    </ListboxGroup>
</template>
